import IntegrationsLogsTable from './integrationsLogsTable.container';

export default IntegrationsLogsTable;
